import { useContext, useEffect } from 'react';
import { PopupControllerContext, PopupHost } from './PopupController';

export const PopupSlot = ({ ...popupHost }: PopupHost) => {
  const { initiate, cancel } = useContext(PopupControllerContext);

  useEffect(() => {
    initiate(popupHost);

    return () => cancel();
  }, []);

  return null;
};
